// extracted by mini-css-extract-plugin
export default {"button":"scrollToTop_button__55DYr","mobile":"scrollToTop_mobile__pm6SO"};